module.exports = __webpack_public_path__ + "static/img/toia-robert.02e5ded.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/toia-robert.jpg
// module id = oOAr
// module chunks = 0